var _circle, _circle2, _circle3, _circle4, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMolecule = function SvgMolecule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#molecule_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 53.188,
    height: 53.188,
    x: 11.406,
    y: 15.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#molecule_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#molecule_svg__c)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 39,
    r: 16,
    fill: "url(#molecule_svg__d)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 39,
    r: 15.5,
    stroke: "#fff",
    strokeOpacity: 0.15,
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 53.188,
    height: 53.188,
    x: 8.406,
    y: -6.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#molecule_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#molecule_svg__f)",
    shapeRendering: "crispEdges"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 16,
    fill: "url(#molecule_svg__g)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 16,
    fill: "url(#molecule_svg__h)",
    fillOpacity: 0.25,
    style: {
      mixBlendMode: "screen"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 15.5,
    stroke: "#fff",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 53.188,
    height: 53.188,
    x: -7.594,
    y: 5.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#molecule_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#molecule_svg__j)",
    shapeRendering: "crispEdges"
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 29,
    r: 16,
    fill: "url(#molecule_svg__k)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 29,
    r: 16,
    fill: "url(#molecule_svg__l)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 29,
    r: 15.5,
    stroke: "#fff",
    strokeOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "molecule_svg__b",
    transform: "translate(-11.406 -15.055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 39,
    r: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "molecule_svg__e",
    transform: "translate(-8.406 6.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "molecule_svg__i",
    transform: "translate(7.594 -5.055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 29,
    r: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "molecule_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "molecule_svg__d",
    x1: 39.044,
    x2: 39.044,
    y1: 23.428,
    y2: 71.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "molecule_svg__g",
    x1: 35,
    x2: 35,
    y1: 15.2,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "molecule_svg__k",
    x1: 19,
    x2: 19,
    y1: 27.2,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "molecule_svg__c",
    width: 53.188,
    height: 53.188,
    x: 11.406,
    y: 15.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "molecule_svg__f",
    width: 53.188,
    height: 53.188,
    x: 8.406,
    y: -6.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "molecule_svg__j",
    width: 53.188,
    height: 53.188,
    x: -7.594,
    y: 5.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "molecule_svg__h",
    width: 2,
    height: 2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#molecule_svg__m",
    transform: "scale(.00195)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "molecule_svg__l",
    width: 2,
    height: 2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#molecule_svg__m",
    transform: "scale(.00195)"
  })))));
};
export default SvgMolecule;